// .skin files (RE_RegisterSkin, tr_image.c): "surface, shader" pairs, plus
// "md3_<type>, model" lines naming accessory models (ET); tag_ lines are ignored.

export interface Skin {
  /** Lower-case surface name -> shader name. */
  surfaces: Map<string, string>;
  /** md3_* type (lower case) -> model path. */
  models: Map<string, string>;
}

/** CommaParse-style tokens: words or "quoted strings", commas and whitespace separate, comments skipped. */
function commaTokens(text: string): string[] {
  const out: string[] = [];
  let i = 0;
  while (i < text.length) {
    const c = text[i];
    if (c <= ' ' || c === ',') {
      i++;
    } else if (c === '/' && text[i + 1] === '/') {
      while (i < text.length && text[i] !== '\n') i++;
    } else if (c === '/' && text[i + 1] === '*') {
      const end = text.indexOf('*/', i + 2);
      i = end < 0 ? text.length : end + 2;
    } else if (c === '"') {
      const end = text.indexOf('"', i + 1);
      out.push(text.slice(i + 1, end < 0 ? text.length : end));
      i = end < 0 ? text.length : end + 1;
    } else {
      const start = i;
      while (i < text.length && text[i] > ' ' && text[i] !== ',') i++;
      out.push(text.slice(start, i));
    }
  }
  return out;
}

export function parseSkin(text: string): Skin {
  const skin: Skin = { surfaces: new Map(), models: new Map() };
  const tokens = commaTokens(text);
  for (let i = 0; i < tokens.length; ) {
    const name = tokens[i++].toLowerCase();
    // like RE_RegisterSkin, a tag_ line only consumes its name
    if (name.startsWith('tag_') || i >= tokens.length) continue;
    const value = tokens[i++];
    if (name.startsWith('md3_')) skin.models.set(name, value);
    else skin.surfaces.set(name, value);
  }
  return skin;
}
